// extracted by mini-css-extract-plugin
module.exports = {"divider":"AccountMenuComponent_divider__3hcFE"};